import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en/translate.json";
import de from "./locales/de/translate.json";

const resources = {
  en,
  de
};

export const availableLanguages = Object.keys(resources);

i18next.use(initReactI18next).use(LanguageDetector).init({
  resources,
  defaultNS: "common",
  fallbackLng: "en"
});

export default i18next;
